/**
 * Dynamic Detection Utilities
 * For Browser and Client IP identification.
 */

/**
 * Detects the current browser name from the user agent string.
 */
export const getBrowserName = (): string => {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";

    if (userAgent.indexOf("Firefox") > -1) {
        browserName = "Mozilla Firefox";
    } else if (userAgent.indexOf("SamsungBrowser") > -1) {
        browserName = "Samsung Browser";
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
        browserName = "Opera";
    } else if (userAgent.indexOf("Trident") > -1) {
        browserName = "Microsoft Internet Explorer";
    } else if (userAgent.indexOf("Edge") > -1 || userAgent.indexOf("Edg") > -1) {
        browserName = "Microsoft Edge";
    } else if (userAgent.indexOf("Chrome") > -1) {
        browserName = "Google Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
        browserName = "Apple Safari";
    }

    return browserName;
};

/**
 * Fetches the user's public IP address using ipify API.
 * This is asynchronous and should be called at app startup or before the first API call.
 */
let cachedIP: string | null = null;

export const fetchClientIP = async (): Promise<string> => {
    if (cachedIP) return cachedIP;

    try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        cachedIP = data.ip;
        return data.ip;
    } catch (error) {
        console.error("Failed to fetch client IP:", error);
        // Fallback to a default if necessary, though ideally we handle this in the UI
        return "127.0.0.1";
    }
};

/**
 * Provides immediate access to the browser name.
 */
export const BROWSER_NAME = getBrowserName();
